import { BaseModel } from "./BaseModel";
import { ColumnHeaders, TabNames } from '../modules/Constants';

export class ExchangeRateModel extends BaseModel {

    supplementalFormatting(formatting) {
        formatting.rows.forEach((row) => {
            row.cells.forEach((cell, columnIndex) => {
                if (columnIndex === 0) {
                    cell.style = this.defaultHeader();
                }
            })
        })

        return formatting;
    }

    constructor() {
        super();
        this.TabName =  TabNames.FX_RATES;
        this.TabIndex = 10;
        this.DataProcessor = new ExchangeRateProcessor();
    }
}

export class ExchangeRateProcessor {
    Currencies;
    ExchangeRates;
    Years;
    Records;
    Headers;

    process(data){

        this.ExchangeRates = [];
        this.Currencies = [];
        this.Records = [];
        this.Headers = [];

        let study = data.study;

        study.exchangeRates.forEach(rate => {
            rate.Item2.Values.forEach(item => {
                this.ExchangeRates.push({
                    currency: rate.Item1,
                    year: new Date(item.Date).getUTCFullYear(),
                    value: item.Value
                });
            });
        });

        this.Years = [... new Set(this.ExchangeRates.map(x => x.year))]
        this.Years.sort();

        this.Currencies = [...new Set(this.ExchangeRates.map(x => x.currency))].map(x => {
            return { key: x, value: x }
        });


        this.Currencies.forEach(currency => {
            let row = [];

            row.push(currency.value);

            this.Years.forEach(year => {
                row.push(this.ExchangeRates.find(item => item.year == year && item.currency == currency.value).value)
            })

            this.Records.push(row);
        })

        this.configureHeader();

        let result = {
            headers: this.Headers,
            display: this.getDisplay(),
            numerics: this.getNumerics()
        };

        return result;
    }

    configureHeader(){
        let header = [ColumnHeaders.CURRENCY_PREFIX];

        this.Years.forEach(year => {
            header.push(year);
        });

        this.Headers = header;
    }

    getDisplay() {
        let display = [];

        display.push(this.Headers);

        this.Records.forEach(record => {
            display.push(record);
        })

        return display;
    }

    getNumerics() {
        let numeric = [];

        //set number formatting
        let startCost = 1;
        let endCost = this.Headers.length;

        numeric.push({ start: startCost, end: endCost });

        return numeric;
    }
}